import React, { Component } from 'react';
import { Select } from 'antd';
import moment from 'moment-timezone';

export default class BaseWeeklyPage extends Component {
  componentWillMount() {
    if(!this.startDateFromUrl || !moment.unix(this.startDateFromUrl).isValid() || this.isAvailableDate(moment.unix(this.startDateFromUrl))) {
      this.setQueryParam('startDate', this.defaultDate);
    }
  }

  get defaultDate() {
    switch(this.props.selectedChurch.revival.phase) {
      case 0:
        return this.props.revivalWeeks[0].startDate;
      case 3:
        return this.props.revivalWeeks[this.props.revivalWeeks.length - 1].startDate;
      default:
        return moment().tz(this.props.selectedChurch.timezone).startOf('day').unix();
    }
  }

  get periodStartDate() {
    return moment.unix(this.weekFromUrl.startDate).tz(this.props.selectedChurch.timezone);
  }

  get periodEndDate() {
    return moment.unix(this.weekFromUrl.endDate).tz(this.props.selectedChurch.timezone);
  }

  get startDateFromUrl() {
    const query = new URLSearchParams(this.props.history.location.search);
    return query.get('startDate');
  }

  get weekFromUrl() {
    const startDate = this.startDateFromUrl;
    return this.getRevivalWeek(startDate) || this.props.revivalWeeks[0];
  }

  get weekName() {
    return {
      0: (phaseWeekNumber) => `Week ${phaseWeekNumber} Before Event`,
      1: (phaseWeekNumber) => `Week ${phaseWeekNumber} of Event Preparation`,
      2: (phaseWeekNumber) => `Week ${phaseWeekNumber} of Event`,
      3: (phaseWeekNumber) => `Week ${phaseWeekNumber} of non-Event mode`
    }
  }

  get weekSelector() {
    return (
      <Select showSearch style={{ width: 250 }} placeholder="Select a week" optionFilterProp="children"
              onChange={this.onWeekChange} filterOption={this.getWeekSelectFilterOptions}
              value={this.getWeekKey(this.weekFromUrl)}>
        {
          this.props.revivalWeeks.map(week => {
            const weekId = this.getWeekKey(week);
            return (
              <Select.Option key={weekId} value={weekId}>
                {this.weekName[week.phaseNumber](week.weekNumber)}
              </Select.Option>
            );
          })
        }
      </Select>
    );
  }

  isAvailableDate(current) {
    const startDate = moment.unix(this.props.revivalWeeks[0].startDate);
    const endDate = moment.unix(this.props.revivalWeeks[this.props.revivalWeeks.length - 1].endDate);
    return !current.isBetween(startDate, endDate, null, "[]");
  }

  getRevivalWeek(date) {
    return this.props.revivalWeeks.find(week => {
      return moment.unix(date).isBetween(moment.unix(week.startDate), moment.unix(week.endDate)) || week.startDate === parseInt(date, 10);
    });
  }

  setQueryParam(param, value) {
    const query = new URLSearchParams(this.props.history.location.search);
    query.set(param, value);
    this.props.history.push({ search: query.toString() });
  }

  getWeekSelectFilterOptions(input, option) {
    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }

  getWeekKey(week) {
    return `${week.phaseNumber}_${week.weekNumber}`;
  }

  getWeek(weekKey) {
    const [phaseNumber, weekNumber] = weekKey.split('_').map(string => parseInt(string, 10));
    return this.props.revivalWeeks.find(week => week.phaseNumber === phaseNumber && week.weekNumber === weekNumber);
  }

  onWeekChange = (weekKey) => {
    this.setQueryParam('startDate', this.getWeek(weekKey).startDate);
  };
}



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/baseWeeklyPage.js